import React from 'react';
import { Section, SectionTitle } from '@repo/components/containers';
import Contact from '@repo/utils/models/Contact';

export function ContactEducation({
  contact,
  underline = true,
}: {
  contact: Contact;
  underline?: boolean;
}) {
  if (!contact.educations || contact.educations.length === 0) {
    return null;
  }

  return (
    <Section>
      <SectionTitle underline={underline}>Education</SectionTitle>
      {contact.educations.map((education, i) => (
        <div key={i}>
          <div className="title">{education.name}</div>
          {education.degree}
        </div>
      ))}
    </Section>
  );
}
